import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m22 6.38-2.55 2.471m-6.28-2.47L17 2.603"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.045 11.671a9.95 9.95 0 0 1 2.492-4.166l1.347-3.433a1.269 1.269 0 0 1 2.444.581l-.208 2.231a1.79 1.79 0 0 0 1.784 1.959h4.78c.582 0 1.053.471 1.053 1.053V9.9c0 .581-.471 1.052-1.053 1.052h-2.98M6.597 21.762 5.375 23m-3.083-5.683 3.307-3.35M14.695 15.163h1.756a1.055 1.055 0 0 1 0 2.11h-2.499"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.45 15.164h1.517a1.054 1.054 0 1 0 0-2.106h-.414"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.701 13.058h3.431a1.053 1.053 0 1 0 0-2.106h-1.556"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m7.865 12.93-.483-.836a1.24 1.24 0 0 0-2.149 1.24l.483.837a1.24 1.24 0 1 0 2.149-1.24M13.64 16.814l-1.437-1.437a1.054 1.054 0 0 0-1.49 1.49l1.436 1.437a1.054 1.054 0 0 0 1.49-1.49"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m12.149 18.304-1.437-1.437a1.054 1.054 0 0 0-1.49 1.49l1.437 1.437a1.054 1.054 0 0 0 1.49-1.49"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m10.403 19.537-1.18-1.18a1.054 1.054 0 0 0-1.49 1.49l1.18 1.18a1.054 1.054 0 1 0 1.49-1.49"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m8.56 20.675-.828-.828a1.054 1.054 0 0 0-1.49 1.49l.828.828a1.054 1.054 0 0 0 1.49-1.49"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const SosHandIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
